import { createContext, useContext, useState, useCallback } from 'react';
import Toast from '@/components/common/Toast';

const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within ToastProvider');
  }
  return context;
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'info', title = '', duration = 3000) => {
    const id = Date.now() + Math.random();
    const toast = { id, message, type, title };

    setToasts((prev) => [...prev, toast]);

    if (duration > 0) {
      setTimeout(() => {
        removeToast(id);
      }, duration);
    }

    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const toast = {
    success: (message, title = '', duration = 3000) => addToast(message, 'success', title, duration),
    error: (message, title = '', duration = 4000) => addToast(message, 'error', title, duration),
    warning: (message, title = '', duration = 3500) => addToast(message, 'warning', title, duration),
    info: (message, title = '', duration = 3000) => addToast(message, 'info', title, duration),
    custom: (message, type, title = '', duration = 3000) => addToast(message, type, title, duration),
  };

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <Toast toasts={toasts} removeToast={removeToast} />
    </ToastContext.Provider>
  );
};
